package com.cybergstudios.rtc.ai

import com.cybergstudios.rtc.engine.GameState

data class AgentOpponent(var coolDownDown: Int = 0) {

    fun processOpponentMove(state: GameState) {
        // if the ball is halfway down don't do anything to avoid player seizures
        // due to the erratic behavior of the opponent paddle.
        if (state.ball.y < 0.0 || state.ball.vel.y < 0.0) {
            return
        }

        // Calculate which side to move
        val xBall: Double = state.ball.x
        val xPaddle: Double = state.paddleOpponent.xCenter()
        val diff: Double = xPaddle - xBall
        if (diff >= 0.0) {
            state.paddleOpponent.moveLeft()
        } else {
            state.paddleOpponent.moveRight()
        }
    }
}